import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromVouchers from '../reducers/voucher.reducer';

export const selectFeatureState = createFeatureSelector<fromVouchers.State>(fromVouchers.featureKey);

export const {
  selectIds: selectVoucherIds,
  selectEntities: selectVoucherEntities,
  selectAll: selectAllVouchers,
  selectTotal: selectTotalVouchers
} = fromVouchers.adapter.getSelectors(selectFeatureState);
export const selectVouchersLoading = createSelector(selectFeatureState, ({loading}) => loading);
